<style lang="scss" scoped>
@import "core";

</style>



<template>
  <div id="pg-app" v-if="subjectsIsLoaded">

    <!-- PC -->
    <table class="pgAvgTbl pgAvgTblPc mdTable01 mt10">
      <thead>
        <tr>
          <th class="pgAvgTblCol1">教科</th>
          <th class="pgAvgTblCol2">科目</th>
          <!-- <th class="pgAvgTblCol3" v-html="props.ttlSelfCheck"></th> -->
          <th class="pgAvgTblCol4" v-html="props.ttlThisYear"></th>
          <th class="pgAvgTblCol6" v-html="props.ttlLastYear"></th>
        </tr>
      </thead>
      <tbody>
        <template v-if="categories" v-for="category, categoryIndex in categories">
          <tr v-for="subject, subjectIndex in category.subjects">
            <template v-if="subjectIndex === 0">
              <th class="pgAvgTblCol1" :rowspan="category.subjects.length">{{category.name}}</th>
            </template>
            <th class="pgAvgTblCol2 pgAvgTblSubSubjectName mdTableLead">{{subject.name}}</th>
            <!-- <td>{{$store.getters['selfcheck/subjectHistory'](subject.id).score}}</td> -->
            <td class="mdCol01">{{subject.thisYear}}</td>
            <td>{{subject.lastYear}}</td>
          </tr>
        </template>
      </tbody>
    </table>

    <!-- SP -->
    <table class="pgAvgTbl pgAvgTblSp mdTable01 mt10">
      <thead>
        <tr>
          <!-- <th class="pgAvgTblCol1" v-html="props.ttlSelfCheck"></th> -->
          <th class="pgAvgTblCol2" v-html="props.ttlThisYear"></th>
          <th class="pgAvgTblCol4" v-html="props.ttlLastYear"></th>
        </tr>
      </thead>
      <tbody>
        <template v-for="category, categoryIndex in categories">
          <tr>
            <th class="pgAvgTblSubjectName" colspan="4">{{category.name}}</th>
          </tr>
          <template v-for="subject, subjectIndex in category.subjects">
            <tr>
              <th class="pgAvgTblSubSubjectName mdTableLead" colspan="4">{{subject.name}}</th>
            </tr>
            <tr>
              <!-- <td>{{$store.getters['selfcheck/subjectHistory'](subject.id).score}}</td> -->
              <td class="mdCol01">{{subject.thisYear}}</td>
              <td>{{subject.lastYear}}</td>
            </tr>
          </template>
        </template>
      </tbody>
    </table>

  </div>
</template>



<script>

/**
 * CMSから科目IDを出力できないため、
 * js側でCMSが出力する科目名に対する科目コードを保持しておく
 * ※1文字でも異なった場合コードを参照できないので注意
 *   曖昧一致は安全のため行わない
 */
// const SUBJECTS_DEFAULT_TABLE = {
//   "106": "国語",
//   "461": "地理総合，地理探究",
//   "462": "歴史総合，日本史探究",
//   "463": "歴史総合，世界史探究",
//   "464": "公共，倫理",
//   "465": "公共，政治・経済",
//   "466": "地理総合",
//   "467": "歴史総合",
//   "468": "公共",
//   "411": "旧世界史A",
//   "412": "旧世界史B",
//   "421": "旧日本史A",
//   "422": "旧日本史B",
//   "431": "旧地理A",
//   "432": "旧地理B",
//   "453": "旧現代社会",
//   "451": "旧倫理",
//   "452": "旧政治・経済",
//   "454": "旧倫理，旧政治・経済",
//   "222": "数学I，数学A",
//   "221": "数学I",
//   "226": "数学II，数学B，数学C",
//   "225": "旧数学I・旧数学A",
//   "225": "旧数学I",
//   "224": "旧数学II・旧数学B",
//   "223": "旧数学II",
//   "902": "旧簿記・会計",
//   "903": "旧情報関係基礎",
//   "512": "物理基礎",
//   "522": "化学基礎",
//   "532": "生物基礎",
//   "542": "地学基礎",
//   "513": "物理",
//   "523": "化学",
//   "533": "生物",
//   "543": "地学",
//   "301": "英語【リーディング】",
//   "311": "英語【リスニング】",
//   "911": "ドイツ語",
//   "912": "フランス語",
//   "913": "中国語",
//   "914": "韓国語",
//   "601": "情報I",
//   "602": "旧情報"
// };



// const getSubjectIdByDefaultName = name => {
//   for (let id in SUBJECTS_DEFAULT_TABLE) {
//     if (name === SUBJECTS_DEFAULT_TABLE[id]) {
//       return id;
//       break;
//     }
//   }
// }



export default {
  data() {
    return {
      props     : null,
      categories: null,
      // histories : {},
      subjectsState: 'pending',
    }
  },



  computed: {
    subjectsIsLoading() { return this.subjectsState === 'loading' },
    subjectsIsLoaded() { return this.subjectsState === 'loaded' },
  },



  methods: {
    async init() {
      this.parseSubjetcsFromHtml();

      this.subjectsState = 'loading';
      // await this.$store.dispatch('selfcheck/load');
      this.subjectsState = 'loaded';
      // console.log(this.$store);
    },

    /**
     * HTMLから科目データをパースして返却
     */
    parseSubjetcsFromHtml() {
      var my = this;

      var categories  = [],
          props       = {},
          $dataTable  = $('#pgAvgTblData'),
          $props      = $dataTable.children('.props'),
          $categories = $dataTable.children('.subjects').children('.subject');

      // props.ttlSelfCheck = $props.find('.ttlSelfCheck').html();
      props.ttlThisYear  = $props.find('.ttlThisYear').html();
      props.ttlLastYear  = $props.find('.ttlLastYear').html();

      $categories.each(function() {
        var category  = {},
            $category = $(this),
            $subjects = $category.find('.subSubjects').children('.subSubject');

        category.name     = $category.find('.subjectName').html();
        category.subjects = [];

        $subjects.each(function() {
          var subject  = {},
              $subject = $(this);

          subject.name     = $.trim($subject.find('.name').text());
          subject.thisYear = $.trim($subject.find('.thisYear').text());
          subject.lastYear = $.trim($subject.find('.lastYear').text());

          // IDはHTML上に出力されていないかもしれない
          // var $id = $subject.find('.id');
          // if ($id.get(0)) {
          //   subject.id = $.trim($subject.find('.id').text());
          // } else {
          //   subject.id = getSubjectIdByDefaultName(subject.name);

          //   if (subject.id === undefined) {
          //     console.warn('科目名 `' + subject.name + '` のIDは定義されていません。');
          //   }
          // }

          category.subjects.push(subject);
        });

        categories.push(category);
      });

      this.props      = props;
      this.categories = categories;
    },
  },


  created() {
    this.init();
  },
}
</script>



// WEBPACK FOOTER //
// App.vue?7bb0c2f0